// Academic Deliverables variant 2 — "Placements"
// Animated vertical salary-package scroll on a primary background (title +
// sub-title + dynamic salary rows), followed by an "Alumni Work At" heading and
// a desktop/mobile recruiter image strip. Ported from the Chandigarh portal's
// Placements organism.

export const ACADEMIC_DELIVERABLES_2_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_salary_package: "₹12 LPA",
    meta_package_description: "Average package",
    meta_priority: 1,
    meta_status: true,
  },

  // Seed rows used by the admin preview when no metadata has been saved yet,
  // so the scrolling animation is visible while editing.
  SEED_METADATA: [
    {
      id: "1",
      meta_salary_package: "₹24 LPA",
      meta_package_description: "Highest package",
      meta_priority: 1,
      meta_status: true,
    },
    {
      id: "2",
      meta_salary_package: "₹12 LPA",
      meta_package_description: "Average package",
      meta_priority: 2,
      meta_status: true,
    },
    {
      id: "3",
      meta_salary_package: "500+",
      meta_package_description: "Hiring partners",
      meta_priority: 3,
      meta_status: true,
    },
  ],

  ACADEMIC_DELIVERABLES_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title",
      value: "Our Placements",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title",
      required: false,
      defaultValue: "Our Placements",
    },
    {
      fieldName: "title_text_color",
      label: "Title Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "sub_title",
      label: "Sub Title",
      value:
        "Our learners are placed at top companies with industry-leading packages.",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Sub Title",
      required: false,
      defaultValue:
        "Our learners are placed at top companies with industry-leading packages.",
    },
    {
      fieldName: "sub_title_text_color",
      label: "Sub Title Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter sub title text color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "section_background_color",
      label: "Section Background Color",
      value: "#db5803",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #db5803)",
      required: false,
      defaultValue: "#db5803",
    },
    {
      fieldName: "recruiters_title",
      label: "Recruiters Heading",
      value: "Alumni {Work At}",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Wrap the highlighted part in { } e.g. Alumni {Work At}",
      required: false,
      defaultValue: "Alumni {Work At}",
    },
    {
      fieldName: "desktop_bg_image",
      label: "Recruiters Image (Desktop)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Desktop Recruiters Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_bg_image",
      label: "Recruiters Image (Mobile)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Mobile Recruiters Image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_image",
      label: "Recruiters Image Alt Text",
      value: "Alumni recruiters",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Image Text",
      required: false,
      defaultValue: "Alumni recruiters",
    },
    {
      fieldName: "status",
      label: "Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Salary Package",
      fieldName: "meta_salary_package",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. ₹12 LPA",
      required: true,
    },
    {
      header: "Package Description",
      fieldName: "meta_package_description",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Average package",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: "",
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enter Status",
    },
  ],
};
